import { render, staticRenderFns } from "./iDSPwdLogin.vue?vue&type=template&id=9339c808"
import script from "./iDSPwdLogin.vue?vue&type=script&lang=js"
export * from "./iDSPwdLogin.vue?vue&type=script&lang=js"
import style0 from "./iDSPwdLogin.vue?vue&type=style&index=0&id=9339c808&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports